// extracted by mini-css-extract-plugin
export var activeLink = "ProductNav-module--activeLink--1360b";
export var fixedC = "ProductNav-module--fixedC--903fb";
export var hasDropdownC = "ProductNav-module--hasDropdownC--eb8f8";
export var link = "ProductNav-module--link--c23a0";
export var links = "ProductNav-module--links--bed38";
export var logo = "ProductNav-module--logo--d7f52";
export var mobileDropdown = "ProductNav-module--mobileDropdown--4a3e8";
export var navSpace = "ProductNav-module--navSpace--e02de";
export var notificationIsShownC = "ProductNav-module--notificationIsShownC--0ac85";
export var root = "ProductNav-module--root--5d25c";
export var space = "ProductNav-module--space--ee9e8";
export var wrapper = "ProductNav-module--wrapper--1c9e6";